export const portalBaseStyle = {
  width: '100%',
  fontSize: '14px',
  lineHeight: '20px',
  border: 'none',
  borderBottom: '1px solid #878787',
  borderRadius: '0',
  boxSizing: 'border-box',
  padding: '8px',
  marginBottom: '28px',
};

const getDisabledStyle = (state) => ({
  control: {
    ...(state.isDisabled && {
      opacity: 0.7,
      color: '#333',
      pointerEvents: 'auto',
      cursor: 'not-allowed',
      backgroundColor: '#f9f9f9',
    }),
  },
  option: {
    ...(state.isDisabled && { cursor: 'not-allowed' }),
  },
});

export const reactSelectStyle = (hidden = false, isMulti = false) => ({
  control: (base, state) => ({
    ...base,
    ...portalBaseStyle,
    ...getDisabledStyle(state).control,
    height: isMulti ? null : '40px',
    minHeight: isMulti ? '40px' : null,
    display: hidden ? 'none' : 'flex',
  }),
  valueContainer: (base, state) => ({
    ...base,
    padding: 0,
    height: isMulti ? null : '26px',
    minHeight: isMulti ? '26px' : null,
  }),
  indicatorsContainer: (base, state) => ({
    ...base,
    height: isMulti ? null : '26px',
    minHeight: isMulti ? '26px' : null,
  }),
  menu: (base, state) => ({
    ...base,
    zIndex: 10,
  }),
  option: (base, state) => ({
    ...base,
    ...getDisabledStyle(state).option,
  }),
});
